import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';

import highchartsAccessibility from 'highcharts/modules/accessibility';

import { getColumnChartConfig } from './getColumnChartConfig';

import type { FC } from 'react';
import type { YAxisPlotLinesOptions } from 'highcharts';

interface ColumnChartProps {
  title: string;
  columnsTitle: string;
  columnLabel: string;
  categories: string[];
  data: number[];
  plotLines?: YAxisPlotLinesOptions[];
  min?: number;
  max?: number;
}

if (typeof Highcharts === 'object') {
  highchartsAccessibility(Highcharts); // Execute the bell curve module
}

export const ColumnChart: FC<ColumnChartProps> = ({
  title,
  columnsTitle,
  columnLabel,
  categories,
  data,
  plotLines = [],
  min,
  max,
}) => {
  const config = getColumnChartConfig(
    title,
    columnsTitle,
    columnLabel,
    categories,
    data,
    plotLines,
    min,
    max
  );

  return <HighchartsReact highcharts={Highcharts} options={config} />;
};
